import { z } from 'zod';
import { HIGHWAY_MAINTENANCE_FEE_PENALTY_STATE_VALUE } from './highwayMaintenanceFeePenaltyTicketState';

const HighwayMaintenanceFeePenaltyTicketAccountSchema = z.object({
  id: z.string(),
  email: z.string(),
});

const HighwayMaintenanceFeePenaltyTicketOperatorNoteSchema = z.object({
  id: z.string(),
  operator: z.string(),
  content: z.string(),
  createDateTime: z.string(),
});

const HighwayMaintenanceFeePenaltyTicketSchema = z.object({
  id: z.string(),
  hmfpAutoPayEnrollmentId: z.string(),
  account: HighwayMaintenanceFeePenaltyTicketAccountSchema,
  plateNumber: z.string(),
  idNumber: z.string().nullable().default(null),
  taxIdNumber: z.string().nullable().default(null),
  state: z.enum(HIGHWAY_MAINTENANCE_FEE_PENALTY_STATE_VALUE),
  amount: z.number().nullable().default(null),
  handlingFee: z.number().nullable().default(null),
  paymentId: z.string().nullable().default(null),
  completeDateTime: z.string().nullable().default(null),
  createDateTime: z.string(),
  updateDateTime: z.string(),
  reason: z.string().nullable().default(null),
  operatorNotes: z
    .array(HighwayMaintenanceFeePenaltyTicketOperatorNoteSchema)
    .default([]),
});

const HighwayMaintenanceFeePenaltyTicketSummarySchema =
  HighwayMaintenanceFeePenaltyTicketSchema.omit({ operatorNotes: true });

type HighwayMaintenanceFeePenaltyTicketAccount = z.infer<
  typeof HighwayMaintenanceFeePenaltyTicketAccountSchema
>;
type HighwayMaintenanceFeePenaltyTicketOperatorNote = z.infer<
  typeof HighwayMaintenanceFeePenaltyTicketOperatorNoteSchema
>;
type HighwayMaintenanceFeePenaltyTicket = z.infer<
  typeof HighwayMaintenanceFeePenaltyTicketSchema
>;
type HighwayMaintenanceFeePenaltyTicketSummary = z.infer<
  typeof HighwayMaintenanceFeePenaltyTicketSummarySchema
>;

export {
  HighwayMaintenanceFeePenaltyTicketAccountSchema,
  HighwayMaintenanceFeePenaltyTicketOperatorNoteSchema,
  HighwayMaintenanceFeePenaltyTicketSchema,
  HighwayMaintenanceFeePenaltyTicketSummarySchema,
};

export type {
  HighwayMaintenanceFeePenaltyTicketAccount,
  HighwayMaintenanceFeePenaltyTicketOperatorNote,
  HighwayMaintenanceFeePenaltyTicket,
  HighwayMaintenanceFeePenaltyTicketSummary,
};
